module.exports = __webpack_public_path__ + "img/goods-empty.3d17159b.png";